import type { RedoMerchantRpcClient } from "@redotech/merchant-sdk/rpc/client";
import type { SetupGuideContextValue } from "./provider/setup-guide-context";
import { getProductConfig } from "./registry/product-registry";
import type { IntakeAnswers, Product } from "./registry/types";

export async function submitSetupGuideIntakeWithActivation({
  product,
  answers,
  setupGuide,
  rpcClient,
  reloadTeam,
  onActivationComplete,
  entrySource,
}: {
  product: Product;
  answers: IntakeAnswers;
  setupGuide: Pick<
    SetupGuideContextValue,
    "setGuideCompletion" | "submitIntake"
  >;
  rpcClient: RedoMerchantRpcClient;
  reloadTeam: () => void | Promise<void>;
  onActivationComplete: () => void | Promise<void>;
  entrySource?: string | null;
}) {
  const config = getProductConfig(product);
  const hasActivationStep = !!config?.onIntakeSubmit;

  if (config?.onIntakeSubmit) {
    try {
      await config.onIntakeSubmit({ entrySource, rpcClient });
    } catch (err) {
      console.warn("setup-guide: onIntakeSubmit failed", { product, err });
      throw new Error(
        `Could not activate ${config.displayName}. Please try again.`,
      );
    }
  }

  await setupGuide.submitIntake(product, answers);
  try {
    await setupGuide.setGuideCompletion(product, true);
  } catch (err) {
    console.warn("setup-guide: setGuideCompletion failed", { product, err });
    throw new Error(
      `Could not finish ${config?.displayName ?? "setup"}. Please try again.`,
    );
  }

  if (hasActivationStep) {
    await reloadTeam();
    await onActivationComplete();
  }
}
